import React from "react";
import { useFormContext } from "react-hook-form";

import { BarcodeStickers, DashedLine } from "../../components";
import { getBarcodeSize } from "../../constants/barcodes";

import { StyledLabelStack } from "./styles";

export const BarcodeRoll = ({ labels, size, format, displayValue }) => {
  const { height, width } = getBarcodeSize(size);
  const pageSize = `${width} ${height}`;

  return (
    <StyledLabelStack
      key={pageSize}
      className="print-only"
      size={pageSize}
      gap="0.0625in"
    >
      {labels?.map(({ barcode, top, bottom }, idx) => {
        const props = {
          barcode,
          top,
          bottom,
          size,
          barcodeProps: { format, displayValue },
        };
        const showDash = labels?.length !== idx + 1;
        return (
          <>
            <BarcodeStickers {...props} />
            {showDash && <DashedLine />}
          </>
        );
      })}
    </StyledLabelStack>
  );
};

export default BarcodeRoll;
